/**
 * Etask.Ui TypeScript Module
 * Haupteinstiegspunkt für alle TypeScript-Funktionen der UI-Bibliothek
 */

// Module imports
import TabPanelModule from './tabs/tabPanelModule';
import CardPanelModule from './tabs/cardTabPanelModule';
import ResizeModule from './general/resizeModule';
import ElementResizeObserverModule from './general/elementResizeObserverModule';
import ContextMenuModule from './contextMenu/contextMenuModule';
import PositionFixedStickyModule from './general/positionFixedStickyModule';
import TableColgroupResizerModule from './table/tableColgroupResizerModule';
import TableStayVisibleModule from './table/tableStayVisibleModule';
import FeedsModule from './lists/feedsModule';
import MentionPickerModule from './mentions/mentionPickerModule';
import SortableListModule from './lists/sortableListModule';
import ToolsModule from './general/toolsModule';
import TooltipModule from './tooltip/tooltipModule';
import DropdownModule from './dropdowns/dropdownModule';
import PopupTabHandlerModule from './popups/popupTabHandlerModule';
import StickyBottomModule from './sticky/stickyBottomModule';
import TabKeyCaptureModule from './general/tabkeyCaptureModule';
import AutoScrollToMarkerModule from './general/autoScrollToMarkerModule';
import TextAreaFieldModule from './fields/textAreaFieldModule';
import ImageEditingModule from './images/imageEditingModule';

// Type imports
import type { IEtaskUiModule } from './types';

/**
 * Hauptobjekt für Etask.Ui JavaScript-Interoperabilität
 */
const EtaskUiModule: IEtaskUiModule = {
    TabPanelModule,
    CardPanelModule,
    ResizeModule,
    ElementResizeObserverModule,
    TableColgroupResizerModule,
    TableStayVisibleModule,
    ContextMenuModule,
    PositionFixedStickyModule,
    FeedsModule,
    MentionPickerModule,
    SortableListModule,
    ToolsModule,
    TooltipModule,
    DropdownModule,
    PopupTabHandlerModule,
    StickyBottomModule,
    TabKeyCaptureModule,
    AutoScrollToMarkerModule,
    TextAreaFieldModule,
    ImageEditingModule
};

PopupTabHandlerModule.initializePopupObserver();
TabKeyCaptureModule.initializeAll();
AutoScrollToMarkerModule.initialize();
TableStayVisibleModule.initializeAll();

// Globalen Zugriff ermöglichen für Blazor Interop
if (typeof window !== 'undefined') {
    // WICHTIG: Stelle sicher, dass window.Etask existiert
    if (!window.Etask) {
        window.Etask = {};
    }
    // Setze window.Etask.Ui
    window.Etask.Ui = EtaskUiModule;
}

export default EtaskUiModule;
